import axiosInstance from './axiosInstance';

export const errorLogsApi = {
  /**
   * Get paginated error logs with filters
   */
  getErrorLogs: async ({
    page = 0,
    size = 20,
    severity,
    resolved,
    startDate,
    endDate,
    search,
    sortBy = 'timestamp',
    sortDir = 'desc'
  } = {}) => {
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('size', size);
      params.append('sortBy', sortBy);
      params.append('sortDir', sortDir);

      if (severity) params.append('severity', severity);
      if (resolved !== undefined && resolved !== null && resolved !== '') {
        params.append('resolved', resolved);
      }
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      if (search) params.append('search', search);

      const response = await axiosInstance.get(`/Corrohealth/api/admin/errors?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get dashboard statistics
   */
  getDashboardStats: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/api/admin/errors/dashboard');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get error trends for chart
   */
  getErrorTrends: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/api/admin/errors/trends');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get single error by ID
   */
  getErrorById: async (id) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/api/admin/errors/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Mark error as resolved
   */
  resolveError: async (id, resolutionNotes = '') => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/api/admin/errors/${id}/resolve`, {
        resolutionNotes
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Reopen a resolved error
   */
  reopenError: async (id) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/api/admin/errors/${id}/reopen`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Bulk resolve errors
   */
  bulkResolve: async (ids, resolutionNotes = '') => {
    try {
      const response = await axiosInstance.post('/Corrohealth/api/admin/errors/bulk-resolve', {
        ids,
        resolutionNotes
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Delete an error log
   */
  deleteError: async (id) => {
    try {
      const response = await axiosInstance.delete(`/Corrohealth/api/admin/errors/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
